import { Gate31ApiV2 } from '@gate31/core/src/api/gate31-api';
import { ImshopItem, Item } from '@gate31/types/cart';
import Client from '@gate31/uikit/common/components/client/client';
import ajaxAPI from 'ajaxAPI';
import Cart from 'Cart';
import EventBus from 'EventBus';
import $ from 'jquery';
import { debounce } from 'lodash';
const CART_COOKIE_ID = 'cookie-cart';

export class RemoteCart {
    static updateRemoteCart =
        debounce(async () => {
            const imshopCart = this.cartToImshopFormat();
            const cookieCart = this.imshopToCookieFormat(imshopCart);

            if ($?.cookie?.(CART_COOKIE_ID) === cookieCart) return;

            $?.cookie?.(CART_COOKIE_ID, cookieCart, { path: '/' });
            const now = Date.now();
            const client = await Client.get();

            if (client.status === 'ok') await Gate31ApiV2.updateCartFields(client.client.id, client.client.phone ?? '', imshopCart, now);
        }, 500);

    static async prepareCartForSync() {
        const cartField = await Client.getCartField('no-store');

        if (! cartField) return;

        const cart = this.parseCartField(cartField);
        const existing: string | undefined = $?.cookie?.(CART_COOKIE_ID);

        if (existing === this.imshopToCookieFormat(cart)) return;

        $?.cookie?.(CART_COOKIE_ID, this.imshopToCookieFormat(cart), { path: '/' });
        Cart.clear();
    }

    static populateSyncCart() {
        const cart: Item[] = JSON.parse($?.cookie?.(CART_COOKIE_ID));

        const items = cart.reduce((acc, cur) => {
            acc[Number(cur.id)] = cur.quantity;
            return acc;
        }, {} as Record<number, number>);

        ajaxAPI.cart.update(items, {}).done((data: any) => {
            EventBus.publish('sync-ready', data);
        });
    }

    private static imshopToCookieFormat(cart: ImshopItem[]) {
        const items: Item[] = cart.map(item => ({ id: item.configurationId, quantity: item.quantity }));

        return JSON.stringify(items);
    }

    private static cartToImshopFormat() {
        const lines = Cart.order.order_lines;

        const imshopItems = lines.map((l): ImshopItem => ({
            configurationId: l.variant_id.toString(),
            id: l.product_id.toString(),
            name: l.title,
            price: l.sale_price,
            privateId: l.variant_id.toString(),
            quantity: l.quantity,
            selected: true,
            subtotal: l.total_price
        }));

        return imshopItems;
    }

    private static parseCartField(cartFieldValue: string) {
        const temp = document.createElement('p');

        temp.innerHTML = cartFieldValue;
        const result = JSON.parse(temp.textContent ?? '') as ImshopItem[];

        temp.remove();
        return result;
    }
}
